<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emEpcTagResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"

                                      ignore-delete
                                      edit-disable
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      with-custom-row-actions-first-column
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                                type="edit" custom-icon="fa fa-fw fa-lg fa-check-circle"
                                                v-if="customRowScope.row.isActive===1"
                                                class="btn btn-outline-primary btn-sm"
                                                customLabel="启用"
                                                @click="activeOrDeActive(customRowScope.row,0)">
                                        </em-button>
                                        <em-button
                                                type="edit" custom-icon="fa fa-fw fa-lg fa-close"
                                                v-if="customRowScope.row.isActive===0"
                                                class="btn btn-outline-primary btn-sm"
                                                customLabel="停用"
                                                @click="activeOrDeActive(customRowScope.row,1)">
                                        </em-button>
                                        <em-button
                                                type="edit" custom-icon="fa fa-fw fa-lg fa-refresh"
                                                v-if="customRowScope.row.isReusable"
                                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                                custom-label="重新绑定"
                                                @click="handleRebind(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
<!--        <el-dialog-->
<!--                title="重新绑定EPC 标签"-->
<!--                :visible="showRebindDialog"-->
<!--                width="400px"-->
<!--                :modal="false"-->
<!--                append-to-body-->
<!--                @close="handleCancel"-->
<!--        >-->
<!--            <div>-->
<!--                <el-form label-width="100px">-->
<!--                    <el-form-item label="业务模块" required>-->
<!--                        <el-select v-model="tagBusinessCode" placeholder="请选择业务模块">-->
<!--                            <el-option-->
<!--                                    v-for="item in businessOption"-->
<!--                                    :key="item.value"-->
<!--                                    :label="item.label"-->
<!--                                    :value="item.value"-->
<!--                            />-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="业务数据Id" required>-->
<!--                        <el-input-->
<!--                                v-model="bindId"-->
<!--                                placeholder="请选择业务数据Id"-->
<!--                                type="number"-->
<!--                                :readonly="true"-->
<!--                        >-->
<!--                            <template slot="append">-->
<!--                                <el-button icon="el-icon-search" @click="$refs.bindIdSelected.showModal()" />-->
<!--                            </template>-->
<!--                        </el-input>-->
<!--                    </el-form-item>-->
<!--                </el-form>-->
<!--            </div>-->

<!--            <div slot="footer" class="dialog-footer">-->
<!--                <el-button @click="handleCancel">取消</el-button>-->
<!--                <el-button type="primary" :loading="loading" :disabled="!tagBusinessCode" @click="reBind()">确定重新绑定 </el-button>-->
<!--            </div>-->
<!--        </el-dialog>-->

        <b-modal
                v-model="showRebindDialog"
                title="重新绑定EPC 标签"
                size="lg"
                no-close-on-backdrop
                no-close-on-esc
                :append-to-body="true"
        >
            <b-form >
                <b-form-group label="业务模块" label-for="business-select" label-cols-sm="4" label-align-sm="left" label-size="lg" required>
                    <b-form-select
                            size="lg"
                            id="business-select"
                            @change="handleBusinessSelect"
                            v-model="tagBusinessCode"
                            :options="businessOption"
                            placeholder="请选择业务模块"
                    ></b-form-select>
                </b-form-group>

                <b-form-group label="业务数据Id" label-for="bind-id-input" label-cols-sm="4" label-align-sm="left" label-size="lg" required>
                    <b-input-group>
                        <b-form-input
                                id="bind-id-input"
                                v-model="bindId"
                                type="number"
                                size="lg"
                                readonly
                                placeholder="请选择业务数据Id"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button variant="outline-secondary" @click="$refs.bindIdSelected.showModal()">
                                <i class="fa fa-search"></i> <!-- Bootstrap Icons 搜索图标，需自行引入 -->
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-form>

            <template #modal-footer>
                <b-button variant="secondary" @click="handleCancel">取消</b-button>
                <b-button
                        variant="primary"
                        :disabled="!tagBusinessCode"
                        :busy="loading"
                        @click="reBind"
                >
                    确定重新绑定
                </b-button>
            </template>
        </b-modal>
        <em-modal-normal-input-entity-selector ref="bindIdSelected" :entity="bindEntity()"
                                               @entityModalSelectSelected="toolsPackageSelected"></em-modal-normal-input-entity-selector>
    </div>
</template>
<script>
    // Author Lidongxu
    // Date 2025-05-27 10:31:08

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import EmModalNormalInputEntitySelector from "@/components/em/EmModal/NormalInputEntitySelector/index.vue";

    export default {
        name: "emEpcTagListView",
        components: {EmModalNormalInputEntitySelector},
        mixins: [emCommonListMixin, emCustomVuexMixin],
        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                loading: false,
                showRebindDialog: false,
                tagBusinessCode: '',
                bindId: undefined,
                currentRow: null,
                businessOption: [
                    {value: 1, text: "工具/刀具",entity:"emArchTool"},
                    {value: 2, text: "吊索具",entity:"emArchBasicData"},
                    {value: 3, text: "固定资产",entity:"emArchTool"},
                    {value: 4, text: "工装",entity:"sithMesPrdToolsInfo"},
                    {value: 5, text: "量器具",entity:"sithMesQualityToolManage"},
                ]
            };
        },
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        },
        methods: {
            //上挂工装包
            toolsPackageSelected(row) {
               this.bindId = row.id;
            },
            async activeOrDeActive(row,isActive) {
                let params = {
                    epcCode: row.epcCode,
                    isActive: isActive,
                };
                try {
                    this.loading = true;
                    await this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emEpcTag/activeOrDeActiveEpcCode",
                        data: params,
                    }).then(response => {
                        if (response && response.data) {
                            this.$message.success("操作成功");
                        }
                    })
                    this.$emit('success');
                } finally {
                    this.loading = false;
                    this.$refs.emListFilter.doQuery();
                }
            },
            bindEntity() {
                if (this.tagBusinessCode) {
                    console.log("this.tagBusinessCode",this.tagBusinessCode);
                    return this.businessOption.find(item => item.value === this.tagBusinessCode).entity;
                }
                return 'emArchTool';

            },
            async reBind() {
                if(!this.bindId || !this.tagBusinessCode) {
                    this.$message.error("请输入业务数据id或选择业务模块");
                    return;
                }
                let params = {
                    epcCode: this.currentRow.epcCode,
                    bindId: this.bindId,
                    tagBusinessCode: this.tagBusinessCode,
                };
                try {
                    this.loading = true;
                    await this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emEpcTag/reBindEpcCode",
                        data: params,
                    }).then(response => {
                        if (response && response.data) {
                            this.$message.success("绑定成功");
                        }
                    })
                    this.$emit('success');
                } finally {
                    this.tagBusinessCode = null;
                    this.bindId = null;
                    this.currentRow = null;
                    this.loading = false;
                    this.showRebindDialog = false;
                    this.$refs.emListFilter.doQuery();
                }
            },
            handleRebind(row) {
                this.tagBusinessCode = row.tagBusinessCode;
                this.bindId = row.bindId;
                this.currentRow = row;
                this.showRebindDialog = true;
                //this.$refs.rebindDialog.show();
            },
            handleCancel() {
                this.tagBusinessCode = null;
                this.bindId = null;
                this.currentRow = null;
                this.showRebindDialog = false;
            },
            handleBusinessSelect() {
                this.bindId=null;
            }
        }
    };
</script>
<style scoped>
.el-dialog__wrapper {
    z-index: 1000 !important;
}
</style>
